function setCurrentYear() {
  const currentYears = document.querySelectorAll(".current-year");
  currentYears.forEach((el) => {
    el.textContent = new Date().getFullYear().toString();
  });
}

window.addEventListener("DOMContentLoaded", function () {
  setCurrentYear();
  const openModal = document.querySelector(".show-sign .show-btn");
  const closeModal = document.querySelector(".sign-modal .close-btn");
  if (openModal) {
    openModal.addEventListener("click", function () {
      const modal = document.querySelector(".sign-modal");
      if (modal) modal.classList.remove("hidden");
    });
  }
  if (closeModal) {
    closeModal.addEventListener("click", function () {
      const modal = document.querySelector(".sign-modal");
      if (modal) modal.classList.add("hidden");
    });
  }
});
